import React from 'react'

import ProjectBiddingWizardStep from './BiddingWizardStep'
import {useProject} from "../../providers/ClientProjectProvider";
import {Navigate, Route, Routes, useLocation, useNavigate, useOutletContext, useParams} from "react-router-dom";
import {useAuth} from '../../providers/AuthProvider';
import ManageProjectScopeTable from "../client-lead-tools/project-scope/ManageProjectScopeTable";
import ProjectScopeProvider from "../client-lead-tools/project-scope/ProjectScopeProvider";
import ManageTeamScopeLayout from "../client-lead-tools/team-scope/ManageTeamScopeLayout";
import ProjectFormProvider from "../../providers/ProjectFormProvider";
import ManageProjectPositionsScopeTable from "../client-lead-tools/position-scope/ManageProjectPositionsScopeTable";
import ManageCandidateScopeLayout from "../client-lead-tools/candidate-scope/ManageCandidateScopeLayout";

export default class BiddingManageScopeStep extends ProjectBiddingWizardStep {

    static slug = 'manage-scope';
    static path = '/manage-scope';
    static StepHeader = 'Manage Project Scope';

    static StepName = 'Scope';
    static StepTitle = 'Project Scope';

    static stepHeaderFor(project) {
        return project.name
    }

    static iconFor(project) {
        return <i className="tab-icon fas fa-tasks"/>
    }

    static accomplishedForProject(project) {
        return project.hasConfirmedProjectScope();
    }

    constructor(props, context) {
        super(props, context);

        this.briefRef = React.createRef();
        this.state = {
            ...this.state,
            isLoading: false,
            error: null,
        };
    }

    async componentDidMount() {
        super.componentDidMount();
    }


    async onRequest(request) {
        if (this.props.project.isBYO()) {
            return;
        }

        if (this.props.isDisabled) return;

        await this.props.toggleUsability(false);

        let response = await request();

        await this.props.toggleUsability(true);

        return response;
    }

    toggleUsability(toggle) {
        this.props.toggleUsability(toggle);
    }

    toggleDisabled(disabled) {
        this.toggleUsability(!disabled);
    }

    render() {
        return (
            <div className="flex-grow container-fluid flex flex-col items-stretch">
                <div className="px-2 flex flex-col bidding-brief-step">
                    <div className="flex flex-col items-stretch gap-10 px-8 py-10 relative">
                        {this.props.project.isService() ? (
                            <Routes>

                                <Route index element={<ProjectScopeProvider><ManageProjectScopeTable/></ProjectScopeProvider>}/>
                                <Route path=":candidateId/*" element={<ManageTeamScopeLayout/>}/>
                            </Routes>
                        ) : (
                            <Routes>
                                <Route index element={<Navigate to="role" replace={true}/>}/>

                                <Route path="role/*">

                                    <Route index element={<Navigate to={`${TB.first(this.props.project.positions)?.id}`} replace={true}/>}/>

                                    <Route path=":roleId/*">
                                        <Route index element={<ProjectFormProvider><ManageProjectPositionsScopeTable/></ProjectFormProvider>}/>
                                        <Route path=":candidateId/*" element={<ManageCandidateScopeLayout/>}/>
                                    </Route>
                                </Route>
                            </Routes>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const ManageScopeStep = (props) => {
    const {
        project,
        isLoading,
        isProjectUpdating,
        update,
        isDisabled: isProjectDisabled,
        requestSOW,
        postUpdate
    } = useProject();

    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const {auth} = useAuth();

    const {
        toggleUsability,
        queryParams,
        isDisabled: isWizardDisabled,
        goToStep
    } = useOutletContext();

    if (!project) return null;

    if (!auth.canManageClients() || !project.isFixedFee()) {
        return <Navigate to={{...location, pathname: project.detailLink()}} replace={true}/>
    }

    return (
        <BiddingManageScopeStep
            project={project}
            location={location}
            navigate={navigate}
            updateProject={postUpdate}
            toggleUsability={toggleUsability}
            queryParams={queryParams}
            isDisabled={isWizardDisabled || isProjectUpdating}
            goToStep={goToStep}
        />
    )
}
export {
    ManageScopeStep
}